import { http } from 'http';

export default {
  getApps: () => http.get('/cms/apps'),

  getDocumentList: data =>
    http.get(`/cms/${data.locale}/templates`, {
      headers: {
        appId: data.appId,
        partnerId: data.partnerId || 0
      }
    }),

  getElementInfo: data =>
    http.get(
      `/cms/${data.locale}/templates/${data.resource.template.name}/patterns/${data.resource.pattern.id}/elements/${data.resource.element.id}`,
      {
        headers: {
          appId: data.appId,
          partnerId: data.partnerId || 0
        }
      }
    ),

  getPartners: appId =>
    http.get('/cms/partners', {
      headers: {
        appId
      }
    })
};
